import { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { Lock, ArrowLeft } from "lucide-react";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Button } from "@/components/ui/button";
import { toast } from "sonner";
import { useAuth } from "@/context/AuthContext";

function formatErr(detail) {
  if (!detail) return "Login failed";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail)) return detail.map((e) => e.msg || JSON.stringify(e)).join(" ");
  return String(detail);
}

export default function Login() {
  const { login, user } = useAuth();
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);

  useEffect(() => { if (user && user.role === "admin") navigate("/admin"); }, [user, navigate]);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await login(email, password);
      toast.success("Welcome back!");
      navigate("/admin");
    } catch (err) {
      toast.error(formatErr(err.response?.data?.detail) || err.message);
    } finally { setLoading(false); }
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-charcoal grain px-6">
      <div className="relative z-10 w-full max-w-md">
        <a href="/" className="inline-flex items-center gap-2 text-white/60 hover:text-white text-sm mb-6"><ArrowLeft className="w-4 h-4" /> Back to site</a>
        <div className="bg-card rounded-3xl p-8 shadow-2xl">
          <div className="w-12 h-12 rounded-xl bg-primary flex items-center justify-center mb-5"><Lock className="w-6 h-6 text-white" /></div>
          <h1 className="font-display text-2xl font-bold mb-1">Admin Login</h1>
          <p className="text-sm text-muted-foreground mb-6">Smart Living Interiors — leads dashboard</p>
          <form onSubmit={submit} className="space-y-4" data-testid="login-form">
            <div className="space-y-1.5"><Label>Email</Label><Input data-testid="login-email" type="email" value={email} onChange={(e) => setEmail(e.target.value)} placeholder="admin@smartliving.com" /></div>
            <div className="space-y-1.5"><Label>Password</Label><Input data-testid="login-password" type="password" value={password} onChange={(e) => setPassword(e.target.value)} placeholder="••••••••" /></div>
            <Button type="submit" disabled={loading} data-testid="login-submit" className="w-full rounded-full bg-primary text-white hover:bg-primary/90 h-11">{loading ? "Signing in..." : "Sign In"}</Button>
          </form>
        </div>
      </div>
    </div>
  );
}
